import { Component, Input, OnInit } from '@angular/core';
import { ListService } from '@app/common/services/list.service';
import { transformListToFilter } from '@app/common/utils/list.utils';
import { Restangular } from 'ngx-restangular';
import { ListModel } from '@app/common/models/list.model';
import { CallbackModel } from '@app/common/models/callback.model';
import { Callbacks } from '@app/ps/enums/callbacks.enum';
import { FinalSolutionStateEnum } from '@app/ps/enums/final-solution-state.enum';

@Component({
  templateUrl: './occupations-approve-change-final-solution-type-confirm.component.html',
})
export class OccupationsApproveChangeFinalSolutionTypeConfirmComponent implements OnInit {
  @Input() data: any;
  callbacks: CallbackModel;

  private list: ListModel<any>;

  readonly FinalSolutionStateEnum = FinalSolutionStateEnum;

  processed: number = 0;
  saving: boolean = false;

  constructor(
    private listService: ListService,
    private restangular: Restangular,
  ) {
    this.proceed = this.proceed.bind(this);
  }

  ngOnInit() {
    this.list = this.listService.createList('occupations', {
      limit: null,
      filters: Object.assign(
        this.listService.toFilterRequestMessage(transformListToFilter({ filters: this.data.selectEntities.filters })).filters,
        {
          entityId: {
            values: this.data.selectEntities.checkedItems.map((entity: any) => entity.id),
            negation: this.data.selectEntities.inverseSelection,
          }
        }
      )
    });

    this.listService.fetchResult(this.list);
  }

  getActionLabel(): string {
    return this.data.details.action === FinalSolutionStateEnum.APPROVED ? 'schváleno' : 'zamítnuto';
  }

  async proceed() {
    let updatedCount = 0;
    const totalCount = this.list.list.length;
    const failureMap: { [reason: string]: number } = {};

    for (const item of this.list.list) {
      item.finalSolutionState = this.data.details.action;
      item.finalSolutionNote = this.data.details.note || null;
      try {
        await this.restangular.one('occupations', item.id).customPUT(item).toPromise();
        updatedCount++;
      } catch (error) {
        console.log(error);
        const reason = (error && error.data && error.data.message) || (error && error.message) || 'Neznámá chyba';
        failureMap[reason] = (failureMap[reason] || 0) + 1;
      }
    }
    const failedGroups = Object.keys(failureMap).map(reason => ({ reason, count: failureMap[reason] }));
    this.notifyParent(updatedCount, totalCount, failedGroups);
  }

  notifyParent(updatedCount: number, totalCount: number, failedGroups: Array<{ reason: string; count: number }>) {
    this.callbacks.get(Callbacks.DataValidityChanged)({
      isValid: () => false,
      data: {
        updatedCount,
        totalCount,
        failedGroups
      },
    });
  }
}
